itsoftApp.createModule("takeAnim", function () {
    const module = this;

    const init = function (el) {
        const start = function () {
            const takeButton = el.querySelector(".js-take-button");
            const beforeBlocks = el.querySelectorAll(".js-before-block");
            const afterBlocks = el.querySelectorAll(".js-after-block");
            const activeBacteriaEls = el.querySelectorAll(".js-active-bacteria-item");

            let isMobile = false;
            let mm = gsap.matchMedia();

            mm.add("(max-width: 767px)", () => {
                isMobile = true;
            });

            mm.add("(min-width: 768px)", () => {
                isMobile = false;
            });

            const onTakeButtonClick = function (evt) {
                evt.preventDefault();

                if (beforeBlocks.length > 0 && afterBlocks.length > 0) {
                    beforeBlocks.forEach(function (beforeBlock) {
                        beforeBlock.classList.remove("js-show");
                        beforeBlock.classList.add("js-hide");
                    });

                    afterBlocks.forEach(function (afterBlock) {
                        afterBlock.classList.remove("js-hide");
                        afterBlock.classList.add("js-show");
                    });
                }

                gsap.set(activeBacteriaEls, {
                    yPercent: -200,
                });

                gsap.to(activeBacteriaEls, {
                    yPercent: isMobile ? -5 : 0,
                    stagger: {
                        from: "center",
                        amount: 0.1,
                        ease: "0.68, 0.13, 0.42, 1.01"
                    },
                    duration: 1.2,
                    ease: "0.68, 0.13, 0.42, 1.01"
                });
            }

            takeButton && takeButton.addEventListener("click", onTakeButtonClick);
        }

        new itsoftApp.modules.startLoad.callback(start, itsoftApp.libraries.gsap);
    }

    module.init = init;
});